import { Drawer } from "@mantine/core"
import { zodResolver } from "@mantine/form"
import { UseMutateFunction } from "@tanstack/react-query"

import {
  certificateTypeCreateSchema,
  standardsCreateSchema,
} from "@tfg/types/schemas/admin"

import {
  FormConfig,
  FormFieldConfig,
  TypesForm,
} from "../../components/TypesForm"

export type DrawerProps<T> = {
  drawerActions: {
    open: () => void
    close: () => void
    toggle: () => void
  }
  schema: typeof standardsCreateSchema | typeof certificateTypeCreateSchema
  initialValues: T
  mutate: UseMutateFunction<T, unknown, T>
  fields: FormFieldConfig[]
}

export function DrawerForm<T extends Record<string, any>>({
  drawerActions,
  schema,
  initialValues,
  mutate,
  fields,
}: DrawerProps<T>) {
  const formConfig: FormConfig<T> = {
    validate: zodResolver(schema),
    initialValues,
  }

  return (
    <Drawer
      position="right"
      opened={true}
      onClose={() => drawerActions.close()}
      title="Create New Standard"
      size="lg"
    >
      <TypesForm<T>
        formConfig={formConfig}
        elements={fields}
        submitLabel="Create"
        mutate={mutate}
      />
    </Drawer>
  )
}
